<template>
    <!-- content -->
    <section id="content" class="content tvapp-cont tvapp-search-cont">
        <!-- Content Header -->
        <div class="content-header sub-visual">
            <div class="sub-visual-bg"></div>
            <div class="in-sec">
                <div class="tit-wrap centered-c">
                    <h2 class="tit-h2">{{ $t("sdp.tvapp.search.message.001") }}</h2>
                </div>
            </div>
        </div>
        <!-- //content Header -->

        <!-- content Body -->
        <div class="content-body">
            <!-- TV 모델별 앱 검색 영역 -->
            <div class="tv-model-search">
                <div class="tv-model-search-wrap">
                    <div class="tv-model-search-info">{{ $t("sdp.tvapp.search.message.002") }}<br> {{ $t("sdp.tvapp.search.message.003") }}</div>
                    <div class="tv-model-search-btnArea">
                        <!-- 2023.06.20 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
                        <button type="button" class="btn btn-type10 btn-secondary popup-open" aria-controls="popupCountryInfo" aria-haspopup="true" @click="setPopupFocus('country')"><span>{{ $t("sdp.tvapp.search.message.004") }}</span></button>
                        <!-- 2023.06.20 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
                        <button type="button" class="btn btn-type10 btn-secondary popup-open" aria-controls="popupTVModelInfo" aria-haspopup="true" @click="setPopupFocus('tvmodel')"><span>{{ $t("sdp.tvapp.search.message.005") }}</span></button>
                    </div>
                    <div class="search-select-detail">
                        <div class="form-select country-choice">
                            <label for="">{{ $t("gwa.alt.tvapp.search.title.004") }}</label>
                            <select v-model="searchCntryCode" name="sService" id="sService" :title='$t("gwa.alt.tvapp.search.title.001")'>
                                <option value="">{{ $t("sdp.tvapp.search.message.006") }}</option>
                                <template v-for="cntry in cntryList">
                                    <option :value="cntry.cntryCode">{{ cntry.cntryName }}</option>
                                </template>
                            </select>
                        </div>

                        <div class="model-name-input">
                            <label for="tvModelName">{{ $t("gwa.alt.tvapp.search.title.003") }}</label>
                            <input v-model="modelName" type="text" name="tvModelName" id="tvModelName" :placeholder='$t("sdp.tvapp.search.message.007")' :title="$t('gwa.alt.tvapp.search.title.002')" class="form-text" @keyup="keyPress" autocomplete="on" required/>
                            <a href="javascript:;" class="tv-model-search-btn" role="button" aria-controls="tvModelsearch" :aria-label='$t("gwa.alt.tvapp.search.title.005")' @click="Tvmodel()">{{$t("gwa.alt.tvapp.search.title.006")}}</a>
                            <!-- Auto Complete -->
                            <div class="ac-form ac-search-fixed2"></div>
                            <!-- //Auto Complete -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- //TV 모델별 앱 검색 영역 -->

            <!-- TV 모델 검색 결과에 따른 메시지 -->
            <!-- 검색 결과 앱 데이터가 있을 경우 style="display:none;" > style="display:;" 변경 -->
            <div v-if="TmYn=='Y' && loadingYn == 'N' || addLoadingYn == 'Y'" class="tv-model-search-message" style="display:;">
                <div class="tv-model-search-message-wrap">
                    {{ $t("sdp.tvapp.search.message.012",{var1:this.displayModelName,var2:this.searchAppCount}) }}<br>{{ $t("sdp.tvapp.search.message.013") }}
                </div>
            </div>
            <!-- //TV 모델 검색 결과에 따른 메시지 -->
            <!-- S : 2021.08.05 Add - 앱명으로 검색하는 영역 -->
            <div v-if="TmYn=='Y' && loadingYn == 'N' || addLoadingYn == 'Y'" class="app-detail-search" style="display:;">
                <div class="tv-model-search-message-wrap">{{ $t("sdp.tvapp.search.message.014") }}</div>
                <div class="app-detail-search-wrap">
                    <input v-model="searchContents" type="text" name="tvAppName" id="tvAppName" :placeholder='$t("gwa.alt.tvapp.search.title.007")' :title='$t("gwa.alt.tvapp.search.title.008")' class="form-text app-Search" required/>
                    <a href="javascript:;" class="app-detail-search-btn" role="button" aria-controls="AppNameSearch" :aria-label='$t("gwa.alt.tvapp.search.title.009")' @click="typing()">{{$t("gwa.alt.tvapp.search.title.009")}}</a>
                </div>
            </div>
            <!-- E : 2021.08.05 Add -->

            <!-- 검색메뉴 -->
            <div v-if="searchYn=='Y' || TmYn=='Y'" class="tab-type1-wrap in-sec">
                <nav v-show="addLoadingYn == 'N'" class="tab-nav tab-type1 tab-responsive">
                    <ul role="tablist">
                        <li role="presentation" :class="{'is-active' : isTabActive('')}" v-show="appCateList.length > 0">
                            <a href="javascript:;" role="tab" aria-selected="true" @click="goAllSearch()">
                                <span class="tit">{{ $t("sdp.mypage.message.tabbuyall") }}</span>
                            </a>
                        </li>
                        <li v-for="item in appCateList" role="presentation" :class="{'is-active' : isTabActive(item.catCode)}">
                            <a href="javascript:;" role="tab" aria-selected="false" @click="goTabSearch(item.catCode, item.catName)">
                                <span class="tit">{{ item.catName }}<em class="label-type2">{{ item.cnt }}</em></span>
                            </a>
                        </li>
                    </ul>
                </nav>
                <div class="tab-body">
                    <!-- 고도화 ver2 : 클래스 has-search 추가 -->
                    <!-- 고도화 ver2 : 속성 title="정렬순서" 추가 -->
                    <!-- 고도화 ver2 : 속성 aria-label 목록보기 수정 -->
                    <section v-if="searchYn == 'Y'" class="section section-category">
                        <div v-show="addLoadingYn == 'N'" class="section-header has-search">
                            <div class="inner">
                                <h3 class="tit-h3">{{ headerName }}</h3>
                                <!-- 검색영역 -->
                                <div v-show="loadingYn == 'N'" class="search-tvapp-wrap" role="search">
                                    <div class="search-select">
                                        <fieldset>
                                            <legend>{{ $t("gwa.alt.tvapp.wa_etc_2") }}</legend>
                                            <div class="search-form">
												<span class="form-select">
													<select @change="goOrderSearch()" v-model="orderType" :title="$t('gwa.alt.common.wa_title_32')" id="orderSelect">
														<option value="0" selected>{{ $t("sdp.store.search.category_text5") }}</option>
														<!--<option value="1">{{ $t("sdp.store.search.category_text2") }}</option>--> <!-- 2022.04.26 송준형 : REQSDP-1553 - [PCMall] TV앱/TV앱검색 다운로드 정렬 삭제 -->
														<option value="2">{{ $t("sdp.store.search.category_text3") }}</option>
														<option value="3">{{ $t("sdp.store.search.category_text4") }}</option>
														<option value="4">{{ $t("sdp.store.search.category_text1") }}</option>
													</select>
												</span>
                                                <button @click="goOrderSearch()" type="button" class="btn-ico btn-search"><span><i class="ico ico-search2">{{ $t('gwa.alt.common.wa_label_27', { var1 : headerName }) }}</i></span></button>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div class="btn-group">
                                        <button @click="setGridYn('Y')" type="button" class="btn-ico btn-searchGrid" :class="{'is-on' : isGridOn()}" aria-controls="tvAppWrap" aria-selected="true" aria-expanded="true" data-type="image" data-target="app-lists"><span><i class="ico ico-list1">{{ $t('gwa.alt.common.wa_label_29') }}</i></span></button>
                                        <button @click="setGridYn('N')" type="button" class="btn-ico btn-searchGrid" :class="{'is-on' : isListOn()}" aria-controls="tvAppWrap" aria-selected="false" aria-expanded="false" data-type="list" data-target="app-lists"><span><i class="ico ico-list2">{{ $t('gwa.alt.common.wa_label_30') }}</i></span></button>
                                    </div>
                                </div>
                                <!-- //검색영역 -->
                            </div>
                        </div>
                        <div class="section-body" v-if="loadingYn == 'Y' && pagingYn == 'N'">
                            <div class="loading-wrap">
                                <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
                            </div>
                        </div>
                        <div class="section-body" v-else>
                            <div id="tvAppWrap" class="app-lists-wrap">
                                <div class="app-lists" :data-type="setDataType" v-if="searchAppList.length > 0">
                                    <ul>
                                        <li v-for="item in searchAppList">
                                            <div class="item-wrap">
                                                <!-- start-2021.06.29 송준형 : REQSDP-881 - 한국PCMALL 웹접근성 개선 작업요청 -->
                                                <a v-if="item.age >= 18 && userAge < 18" href="javascript:;" class="more-focus popup-open" :title="$t('gwa.alt.common.wa_title_33')" @click="setAdultAppName(item.appName, item.appId)" aria-controls="popupInfoGuide" aria-haspopup="true" :aria-label="$t('gwa.alt.tvapp.wa_label_4', { var1 : item.appName, var2 : item.catName })">
                                                    <p class="item-thumb thumbnail"><img :src="item.appPath" alt="" onerror="imageResize.reset(this)" /></p>
                                                    <p class="item-tit"><strong>{{ item.appName }}</strong></p>
                                                    <p class="item-part" role="text">{{ item.catName }}</p>
                                                </a>
                                                <a v-else href="javascript:;" class="more-focus" :title="$t('gwa.alt.common.wa_title_33')" @click="goTvappDetail(item.appId)" :aria-label="$t('gwa.alt.tvapp.wa_label_4', { var1 : item.appName, var2 : item.catName })">
                                                    <p class="item-thumb thumbnail"><img :src="item.appPath" alt="" onerror="imageResize.reset(this)" /></p>
                                                    <p class="item-tit"><strong>{{ item.appName }}</strong></p>
                                                    <p class="item-part" role="text">{{ item.catName }}</p>
                                                </a>
                                                <!-- end-2021.06.29 송준형 : REQSDP-881 - 한국PCMALL 웹접근성 개선 작업요청 -->
                                                <p class="item-txt"><a href="javascript:;" :title="$t('gwa.alt.tvapp.wa_title_1')" @click="goTvappSeller(item.sellrUsrNo)" class="tracking app_list seller" :aria-label="$t('gwa.alt.tvapp.wa_label_2', { var1 : item.sellrUsrName })">{{ item.sellrUsrName }}</a></p>
                                                <div class="item-star">
                                                    <div class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(item.avgSscr)" :aria-label="$t('gwa.alt.tvapp.wa_label_3', { var1 : appStar(item.avgSscr) })">
                                                        <span class="blind dv-pc-only">{{ $t('gwa.alt.tvapp.wa_label_3', {var1 : appStar(item.avgSscr)}) }}</span>
                                                        <span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <!-- 미등록게시물 -->
                                <div class="noData-wrap" v-else>
                                    <div class="noData">
                                        <div class="inner">
                                            <p><i class="ico ico-waring2" aria-hidden="true"></i><span class="noData-txt">{{$t("gwa.alt.tvapp.search.title.010")}}</span></p>
                                        </div>
                                    </div>
                                </div>
                                <!-- //미등록게시물 -->
                                <!-- 고도화 ver2 : 속성 aria-label 문구수정 -->
                                <template v-if="searchAppList.length > 0">
                                    <div class="loading-wrap" v-if="pagingYn == 'Y'">
                                        <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
                                    </div>
                                    <div class="btn-more-wrap" v-else>
                                        <!--<button @click="goNextPage()" type="button" class="btn btn-type9 more-trigger" :aria-label="$t('gwa.alt.common.wa_label_35')+' : '+$t('gwa.alt.common.wa_label_49', { var1 : calTotalPage(), var2 : paging.curPage })"><span>{{ $t('sdp.store.message.showdescription') }}<i class="ico ico-more-tvapp"></i><em class="label-page">{{ paging.curPage }}/{{ calTotalPage() }}</em></span></button>-->
                                        <!--<button type="button" style="display:none;" class="btn btn-type9 more-trigger" aria-label="@(카테고리명) 앱 전체보기"><span>전체보기</span></button> &lt;!&ndash; 2021.08.05 Add - 앱명으로 검색 후 전체보기 버튼 노출(전체 카테고리를 제외한 나머지 카테고리명 전체보기 앞에 노출) &ndash;&gt;-->
                                        <button v-if="lastPageYn=='Y'" type="button" class="btn btn-type9 more-trigger" role="button" :aria-label="$t('gwa.alt.tvapp.search.title.018')" @click="goFirstSearch()">{{catMoreName}}</button>
                                        <button v-else-if="catMoreYn=='N'" type="button" class="btn btn-type9 more-trigger" role="button" :aria-label="$t('gwa.alt.tvapp.search.title.011',{varl:this.headerName})" @click="goNextPage()">{{catMoreName}}</button>
                                        <button v-else type="button" class="btn btn-type9 more-trigger" role="button" :aria-label="$t('gwa.alt.common.wa_label_35')+' : '+$t('gwa.alt.common.wa_label_49', { var1 : calTotalPage(), var2 : paging.curPage })" @click="goNextPage()" ><span>{{ $t('sdp.store.message.showdescription') }}<i class="ico ico-more-tvapp"></i><em class="label-page">{{ paging.curPage }}/{{ calTotalPage() }}</em></span></button>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </section>
                    <!-- 앱목록 전체영역 -->
                </div>
            </div>
            <!-- //검색메뉴 -->

            <!-- 팝업_APP이용안내 -->
            <div id="popupInfoGuide" class="popup-wrap" hidden>
                <div class="popup popup-type1" role="dialog" aria-labelledby="popupInfoGuideTitle">
                    <div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.common.wa_label_55')"><!-- IOS접근성 영역자체에 초점처리 --></div>
                    <div class="popup-container">
                        <div class="popup-header">
                            <h3 class="tit-h3" id="popupInfoGuideTitle">APP {{ $t("sdp.menu.overview") }}</h3>
                        </div>
                        <div class="popup-body popup-scroll">
                            <div class="para-wrap align-c">
                                <p class="para color-primary" v-html="$t('sdp.store.message.minorsapp')"></p>
                                <p class="para" v-html="$t('sdp.store.minorsapp.detailinfo', { var1 : adultAppName })"></p>
                            </div>
                        </div>
                        <div class="popup-footer">
                            <div class="btn-wrap">
                                <button @click="goLgaccount('N')" type="button" class="btn btn-type2 btn-primary"><span>{{ $t("sdp.menu.join_member") }}</span></button>
                                <button @click="goLgaccount('Y')" type="button" class="btn btn-type2 btn-primary"><span>{{ $t("sdp.menu.gnb.lgaccount") }}</span></button>
                                <button type="button" class="btn btn-type2 btn-secondary popup-close" aria-controls="popupInfoGuide" :title="$t('gwa.alt.common.wa_title_58')"><span>{{ $t("sdp.message.layerpopup.close") }}</span></button>
                            </div>
                        </div>
                        <button type="button" class="btn-ico btn-popup-close popup-close" aria-controls="popupInfoGuide" :title="$t('gwa.alt.common.wa_title_58')"><span><i class="ico ico-close2">{{ $t('gwa.alt.common.wa_label_19') }}</i></span></button>
                    </div>
                </div>
            </div>
            <!-- //팝업_APP 이용안내 -->

            <div id="popupTabSelect" class="popup-wrap popup-select" role="dialog">
                <div class="popup popup-tab">
                    <nav class="tab-nav tab-type1 tab-responsive">
                        <ul role="tablist">
                            <li role="presentation" :class="{'is-active' : isTabActive('')}" v-show="appCateList.length > 0">
                                <a href="javascript:;" role="tab" aria-selected="true" @click="goAllSearch()">
                                    <span class="tit">{{ $t("sdp.mypage.message.tabbuyall") }}</span>
                                </a>
                            </li>
                            <li v-for="item in appCateList" role="presentation" :class="{'is-active' : isTabActive(item.catCode)}">
                                <a href="javascript:;" role="tab" aria-selected="false" @click="goTabSearch(item.catCode, item.catName)">
                                    <span class="tit">{{ item.catName }}<em class="label-type2">{{ item.cnt }}</em></span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <button type="button" class="btn-ico btn-close-select" aria-controls="popupTabSelect"><span><i class="ico ico-close2">{{ $t('gwa.alt.common.wa_label_22') }}</i></span></button>
                </div>
            </div>

            <!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
            <div v-show="cntryCode == 'FR'">
                <TermsPop></TermsPop>
            </div>
            <!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->

            <div id="popupCountryInfo" class="popup-wrap" hidden>
                <div class="popup popup-type10 popup-type1" role="dialog" aria-labelledby="popupCountryTitle">
                    <div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.tvapp.search.title.012')"></div>
                    <div class="popup-container">
                        <div class="popup-header">
                            <h3 class="tit-h3" id="popupCountryInfoTitle">{{$t("sdp.tvapp.search.message.004")}}</h3>
                        </div>
                        <!-- 2023.06.20 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
                        <div class="popup-body popup-scroll" id="popupCountryScroll">
                            <div class="para-wrap">
                                <div role="text" class="data-content" v-html="lineBreakCntt(cntryInfo)"></div>
                            </div>
                        </div>
                        <div class="popup-footer">
                            <div class="btn-wrap">
                                <button type="button" class="btn btn-type2 btn-primary popup-close" aria-controls="popupCountryInfo" :title="$t('gwa.alt.tvapp.search.title.013')"><span>{{$t("sdp.mypage.message.confirm2")}}</span></button>
                            </div>
                        </div>
                        <button type="button" class="btn-ico btn-popup-close popup-close" aria-controls="popupCountryInfo" :aria-label="$t('gwa.alt.tvapp.search.title.013')" title=""><span><i class="ico ico-close2"></i></span></button>
                    </div>
                </div>
            </div>

            <div id="popupTVModelInfo" class="popup-wrap" hidden>
                <div class="popup popup-type10 popup-type1" role="dialog" aria-labelledby="popupTVModelTitle">
                    <div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.tvapp.search.title.014')"></div>
                    <div class="popup-container">
                        <div class="popup-header">
                            <h3 class="tit-h3" id="popupTVModelInfoTitle">{{$t("sdp.tvapp.search.message.005")}}</h3>
                        </div>
                        <!-- 2023.06.20 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
                        <div class="popup-body popup-scroll" id="popupTVModelScroll">
                            <div class="para-wrap">
                                <div role="text" class="data-content" v-html="lineBreakCntt(modelInfo)"></div>
                            </div>
                        </div>
                        <div class="popup-footer">
                            <div class="btn-wrap">
                                <button type="button" class="btn btn-type2 btn-primary popup-close" aria-controls="popupTVModelInfo" :title="$t('gwa.alt.tvapp.search.title.015')"><span>{{$t("sdp.mypage.message.confirm2")}}</span></button>
                            </div>
                        </div>
                        <button type="button" class="btn-ico btn-popup-close popup-close" aria-controls="popupTVModelInfo" :aria-label="$t('gwa.alt.tvapp.search.title.015')" title=""><span><i class="ico ico-close2"></i></span></button>
                    </div>
                </div>
            </div>

        </div>
        <!-- //content Body -->
    </section>
    <!-- //content -->
</template>

<script>
    import qs from "qs";
    import TermsPop from '@/components/terms/TermsPop';

    export default {
        name: "TvappSearch",
        components: {
            TermsPop //PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
        },
        data() {
            return {
                appList: [],
                searchAppList: [],
                appCateList: [],
                cntryList: [],
                modelNameAutoSearchList: [],
                searchAppCount: 0,
                userAge: 0,
                modelYn: "",
                cntryYn: "",
                catCode1: "",
                catMoreYn:"N",
                catMoreName:"",
                TmYn:"N",
                orderType: "0",
                headerName: "",
                appRankCode: "",
                appType: "",
                adultAppName: "",
                adultAppId: "",
                loadingYn: "Y",
                pagingYn: "N",
                gridYn: "Y",
                searchContents: "",
                searchYn: "N",
                addLoadingYn: "N",
                modelName: "",
                displayModelName: "",
                orderYn: "N", // 2021.06.29 송준형 : REQSDP-881 - 한국PCMALL 웹접근성 개선 작업요청
                cntryCode: _domainCntryCode,
                searchCntryCode: "",
                cntryInfo: "",
                modelInfo: "",
                cntryInfoYn: "N",
                modelInfoYn: "N",
                lastPageYn: "N",
                prodCode: "P000000035", // 2025.05.12 송준형 : REQSDP-7221 - [PC mall] 프리미엄 App 연동 플랫폼 변경 (W25O)
                plfmCode: "W25O", // 2025.05.12 송준형 : REQSDP-7221 - [PC mall] 프리미엄 App 연동 플랫폼 변경 (W25O)
                paging: {
                    pageList: [],
                    totalCount: 0,
                    pageCount: 0,
                    rowCount: 0,
                    curPage: 1,
                    hasNext: false,
                    hasLast: false,
                    hasPrev: false,
                    hasFirst: false,
                    curMaxPage: 0,
                    curMinPage: 1
                },
                busy: false
            }
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            },
            typing() {
                const vm = this;
                vm.searchContents=$('#tvAppName').val().toLowerCase();
                vm.addLoadingYn = "Y";
                vm.paging.curPage = 1;
                vm.goAllSearch();
            },
            keyPress(e) {
                const vm=this;
                // arrow key down, up
                if(e.which == 40 || e.which == 38) {
                    return;
                }
                if(vm.searchCntryCode==''){
                    vm.modelNameAutoSearchList = [];
                    $("#tvModelName").autocomplete("option", "source", vm.modelNameAutoSearchList);
                    return;
                }
                if(vm.modelName.length < 2) {
                    //2자릿수 이후부터 자동완성로직 시작하므로, 2자리수 미만일경우 autocomplete 초기화
                    vm.modelNameAutoSearchList = [];
                    $("#tvModelName").autocomplete("option", "source", vm.modelNameAutoSearchList);
                    return;
                }

                //Enter
                if (e.which == 13) { 
                    this.Tvmodel();
                } else {
                    this.autoSearchText();
                }
            },
            autoSearchText() {
                const modelName = $('#tvModelName').val().toUpperCase();
                const cntryCode = $('#sService').val().toUpperCase();

                const vm = this;
                var params = {
                    modelName : modelName,
                    cntryCode : cntryCode
                };

                this.$axios.post("/api/tvapp/modelNameAutoSearch.ajax", qs.stringify(params)).then((result) => {

                    console.log("modelNameAutoSearchList", vm.modelNameAutoSearchList);

                    if(result.data.modelNameAutoSearchList == undefined) {
                        vm.modelNameAutoSearchList = [];
                    } else {
                        vm.modelNameAutoSearchList = result.data.modelNameAutoSearchList;
                    }

                    $("#tvModelName").autocomplete("option", "source", vm.modelNameAutoSearchList);
                    $("#tvModelName").autocomplete( "search", modelName );

                }).catch((error) => {
                    ui.loading.close();
                    this.loadingYn = "N";
                    console.log(error);
                    alert("error");
                });
                /*
                this.$axios.post("/api/integratedSearch/retrieveAutoSearch.ajax", qs.stringify(params)).then((result) => {

                    console.log("completeKeywordList", vm.completeKeywordList);

                    if(result.data.completeKeywordList == undefined) {
                        vm.completeKeywordList = [];
                    } else {
                        vm.completeKeywordList = result.data.completeKeywordList;
                    }

                    $("#tvModelName").autocomplete("option", "source", vm.completeKeywordList);
                    $("#tvModelName").autocomplete( "search", keyword );

                }).catch((error) => {
                    ui.loading.close();
                    this.loadingYn = "N";
                    console.log(error);
                    alert("error");
                });
                */
            },
            Tvmodel(){
                const vm=this;
                vm.modelName=$('#tvModelName').val().toUpperCase();
                vm.searchCntryCode=$('#sService').val().toUpperCase();
                vm.catMoreYn="N";

                if(vm.searchCntryCode==''){
                    alert(this.$t("sdp.tvapp.search.message.008"));
                    setFocusScroll('#sService');
                    return;
                }
                if(vm.modelName==''){
                    alert(this.$t("sdp.tvapp.search.message.009"));
                    setFocusScroll('#tvModelName');
                    return;
                }

                const params = {
                    TmYn:vm.TmYn,
                    searchYn:vm.searchYn,
                    modelName:vm.modelName,
                    searchContents:vm.searchContents,
                    cntryCode:vm.searchCntryCode
                };
                vm.loadingYn = "Y";
                vm.goTvModelSearchAjax(params);
            },
            goAllSearch() {
                if(this.busy == true) {
                    return;
                }
                this.busy = true;

                const vm = this;
                vm.loadingYn = "Y";
                vm.headerName = this.$t("sdp.mypage.message.tabbuyall");

                vm.catCode1 = "";
                // vm.moreYn = "N";
                // vm.cateYn = "N";
                vm.orderType = "0";
                // vm.hotAppList = [];
                // vm.newAppList = [];
                // vm.allAppList = [];
                vm.searchAppList = [];
                vm.paging.rowCount = 12;
                vm.paging.curPage = 1;

                vm.goSearchAjax();
            },
            goTabSearch(catCode1, catName) {
                if(this.busy == true) {
                    return;
                }
                this.busy = true;

                const vm = this;
                vm.loadingYn = "Y";
                vm.addLoadingYn = "Y";

                vm.catCode1 = catCode1;
                // vm.moreYn = "N";
                // vm.cateYn = "Y";
                vm.catMoreYn="N";
                vm.orderType = "0";
                vm.lastPageYn = "N";
                vm.headerName = catName;
                // vm.appList = [];
                vm.paging.rowCount = 12;
                vm.paging.curPage = 1;

                vm.goSearchAjax();
            },
            goOrderSearch() {
                if(this.busy == true) {
                    return;
                }
                this.busy = true;

                const vm = this;
                vm.loadingYn = "Y";
                vm.addLoadingYn = "Y";
                vm.orderYn = "Y"; // 2021.06.29 송준형 : REQSDP-881 - 한국PCMALL 웹접근성 개선 작업요청

                // vm.appList = [];
                vm.paging.rowCount = 24;
                vm.paging.curPage = 1;

                vm.goSearchAjax();
            },
            goNextPage() {
                if(this.busy == true) {
                    return;
                }
                this.busy = true;

                const vm = this;
                vm.addLoadingYn = "Y";
                if(vm.catMoreYn == "Y") {
                    if(vm.paging.curPage < vm.calTotalPage()) {
                        vm.pagingYn = "Y";
                        vm.paging.curPage = vm.paging.curPage + 1;
                        vm.paging.rowCount=24;
                        if(vm.paging.curPage == vm.calTotalPage()) {
                            vm.lastPageYn = "Y";
                        }
                        vm.goSearchAjax();
                    } else {
                        vm.busy = false;
                    }
                } else {
                    vm.catMoreYn="Y";
                    vm.paging.rowCount=24;
                    vm.goSearchAjax();
                }
            },
            goFirstSearch() {
                const vm = this;
                vm.lastPageYn = "N";
                vm.searchContents = "";
                $(window).scrollTop(0);
                vm.goAllSearch();
            },
            goTvModelSearchAjax(params) {
                const vm = this;
                ui.loading.open();
                this.$axios.post("/api/tvapp/checkModelName.ajax",
                    qs.stringify(params)).then((result) => {
                    ui.loading.close();
                    vm.loadingYn = "N";
                    vm.modelYn = result.data.modelYn;
                    vm.cntryYn = result.data.cntryYn;

                    if(vm.modelYn == "Y" && vm.cntryYn == "Y") {
                        vm.TmYn="Y";
                        vm.paging.rowCount=12;
                        vm.goSearchAjax();
                    } else {
                        vm.TmYn="N";
                        vm.searchYn="N";
                        vm.modelName="";
                        if(vm.modelYn == "N") {
                            alert(this.$t("sdp.tvapp.search.message.010"));
                            setFocusScroll('#tvModelName');
                        } else {
                            alert(this.$t("sdp.tvapp.search.message.011"));
                            setFocusScroll('#sService');
                        }
                    }
                }).catch((err) => {
                    ui.loading.close();
                    vm.loadingYn = "N";
                    alert("error : " + err);
                });
            },
            changecatName(){
                const vm=this;
                if(vm.lastPageYn == "Y") {
                    vm.catMoreName=this.$t("sdp.support.message.totalView");
                } else {
                    if(vm.catCode1=="")
                    {
                        vm.catMoreName=this.$t("sdp.store.message.showdescription");
                    }else{
                        vm.catMoreName=vm.headerName+" "+this.$t("sdp.store.message.showdescription")
                    }
                }
            },
            goSearchAjax() {
                const vm = this;
                vm.searchYn="Y";
                ui.loading.open();

                const params = {
                    catCode1: vm.catCode1,
                    // moreYn: vm.moreYn,
                    cntryCode: vm.searchCntryCode,
                    catMoreYn:vm.catMoreYn,
                    modelName:vm.modelName,
                    orderType: vm.orderType,
                    appRankCode: vm.appRankCode,
                    prodCode: vm.prodCode, // 2022.04.25 송준형 : REQSDP-1553 - [PCMall] TV앱/TV앱검색 다운로드 정렬 삭제
                    plfmCode: vm.plfmCode, // 2022.04.25 송준형 : REQSDP-1553 - [PCMall] TV앱/TV앱검색 다운로드 정렬 삭제
                    curPage: vm.paging.curPage,
                    rowCount: vm.paging.rowCount,
                    pageCount: vm.paging.pageCount,
                    searchContents: vm.searchContents,
                    totalCount: vm.paging.totalCount,
                    addLoadingYn: vm.addLoadingYn
                };
                    vm.loadingYn="Y";
                    vm.goAllSearchAjax(params);
            },
            goAllSearchAjax(params) {
                const vm = this;
                this.$axios.post("/api/tvapp/retrieveSearchAppList.ajax",
                    qs.stringify(params)).then((result) => {
                    ui.loading.close();
                    vm.searchAppList = result.data.searchAppList;
                    vm.appCateList = result.data.appCateList;
                    vm.userAge = result.data.userAge;
                    vm.catCode1 = result.data.catCode1;
                    vm.loadingYn = "N";
                    vm.pagingYn = "N";
                    vm.displayModelName = vm.modelName;
                    if(vm.addLoadingYn == "N") {
                        vm.searchAppCount = result.data.searchAppCount;
                    }

                    vm.setResult(result);
                    if(vm.paging.totalCount <= 12 || (vm.catMoreYn == 'Y' && vm.paging.totalCount <= 24)) {
                        vm.lastPageYn = "Y";
                    }

                    vm.$nextTick(function() {
                        ui.popup.init();
                        ui.starRating.init();
                        ui.tab.init(); // 2023.06.13 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년
                        ui.tabFolder.init();
                        dimmer.init();
                        ui.common.title();

                        vm.busy = false;
                        if(vm.addLoadingYn == "Y") {
                            vm.addLoadingYn = "N";
                        }
                        vm.changecatName();
                    });
                }).catch((err) => {
                    ui.loading.close();
                    vm.loadingYn = "N";
                    vm.pagingYn = "N";
                    if(vm.addLoadingYn == "Y") {
                        vm.addLoadingYn = "N";
                    }
                    alert("error : " + err);
                    vm.busy = false;
                });
            },
            appStar(avgSscr) {
                if (avgSscr >= 9.5) {
                    return 5;
                } else if (avgSscr >= 8.5) {
                    return 4.5;
                } else if (avgSscr >= 7.5) {
                    return 4;
                } else if (avgSscr >= 6.5) {
                    return 3.5;
                } else if (avgSscr >= 5.5) {
                    return 3;
                } else if (avgSscr >= 4.5) {
                    return 2.5;
                } else if (avgSscr >= 3.5) {
                    return 2;
                } else if (avgSscr >= 2.5) {
                    return 1.5;
                } else if (avgSscr >= 1.5) {
                    return 1;
                } else if (avgSscr >= 0.5) {
                    return 0.5;
                } else {
                    return 0;
                }
            },
            goTvappDetail(appId) {
                const r = { path : "/main/tvapp/detail?appId=" + appId + "&catCode1=" + this.catCode1
                        + "&orderType=" + this.orderType
                        + "&headerName=" + this.headerName + "&appRankCode=" + this.appRankCode + "&sellrUsrNo="
                        + "&curPage=" + this.paging.curPage + "&appSearchYn=Y&searchCntryCode=" + this.searchCntryCode };
                this.$router.push(r);
            },
            goTvappSeller(sellrUsrNo) {
                const r = { path : "/main/tvapp/seller?sellrUsrNo=" + sellrUsrNo };
                this.$router.push(r);
            },
            setResult(result) {
                this.paging.totalCount = result.data.totalCount;
                this.paging.pageCount = result.data.pageCount;
                this.paging.curPage = result.data.curPage;
                this.paging.rowCount = result.data.rowCount;
            },
            calTotalPage() {
                const vm = this;
                const totalPage = parseInt(vm.paging.totalCount / vm.paging.rowCount);
                if(vm.paging.totalCount % vm.paging.rowCount == 0) {
                    return totalPage;
                } else {
                    return totalPage + 1;
                }
            },
            isTabActive(catCode1) {
                if(this.catCode1 == catCode1) {
                    return true;
                } else {
                    return false;
                }
            },
            isGridOn() {
                if(this.gridYn == "Y") {
                    return true;
                } else {
                    return false;
                }
            },
            isListOn() {
                if(this.gridYn == "Y") {
                    return false;
                } else {
                    return true;
                }
            },
            setAdultAppName(appName, appId) {
                this.adultAppName = appName;
                this.adultAppId = appId;
            },
            setGridYn(gridYn) {
                this.gridYn = gridYn;
            },
            lineBreakCntt(cntt) {
                if(cntt != null && cntt != "") {
                    return cntt.split("\n").join("<br />");
                } else {
                    return "";
                }
            },
            setPopupFocus(type) { // 2023.06.20 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년
                if(type == "country") {
                    $("#popupTVModelScroll").removeAttr("tabindex");
                    $("#popupCountryScroll").attr("tabindex", 0);
                    $("#popupCountryScroll").focus();
                } else {
                    $("#popupCountryScroll").removeAttr("tabindex");
                    $("#popupTVModelScroll").attr("tabindex", 0);
                    $("#popupTVModelScroll").focus();
                }
            },
            goLgaccount(loginYn) {
                const vm = this;

                var _params = {
                    appId: vm.adultAppId,
                    catCode1: vm.catCode1,
                    // moreYn: vm.moreYn,
                    // cateYn: vm.cateYn,
                    orderType: vm.orderType,
                    headerName: vm.headerName,
                    appRankCode: vm.appRankCode,
                    sellrUsrNo: "",
                    curPage: vm.paging.curPage
                };

                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                var loginPath = "tvapp/detail?" + qs.stringify(_params);
                const r = { path : "/main/loginLink?path=" + loginPath.replaceAll("&", "-") + "&loginYn=" + loginYn };
                this.$router.push(r);
            }
        },
        computed: {
            setDataType: function() {
                if(this.gridYn == "Y") {
                    return "image";
                } else {
                    return "list";
                }
            }
        },
        mounted() {
            const vm = this;
            vm.loadingYn = "Y";
            vm.headerName = this.$t("sdp.mypage.message.tabbuyall");
            ui.loading.open();

            const params = {
                cntryCode: _domainCntryCode,
                langCode: _domainLangCode
            };

            this.$axios.post("/api/tvapp/retrieveSearchAppInfoList.ajax",
                qs.stringify(params)).then((result) => {
                ui.loading.close();
                vm.cntryList = result.data.cntryList;
                vm.cntryInfo = result.data.cntryInfo;
                vm.modelInfo = result.data.modelInfo;
                vm.loadingYn = "N";

                vm.$nextTick(function() {
                    ui.init();
                    $(window).scrollTop(0);

                    $("#tvModelName").autocomplete({
                        appendTo: ".ac-search-fixed2",
                        source : vm.modelNameAutoSearchList,
                        messages: {
                            noResults: '',
                            results: function() {}
                        },
                        select : function(evt, u) {
                            $("#tvModelName").val(u.item.value);
                            vm.Tvmodel();
                        }
                    });
                });
            }).catch((err) => {
                ui.loading.close();
                alert("error : " + err);
            });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
